import React from 'react'
import { Helmet } from 'react-helmet'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import '../css/index.css'
import useSiteMetadata from './SiteMetadata'
import { withPrefix } from 'gatsby'

const TemplateWrapper = ({ children }) => {
  const { title, description, keywords } = useSiteMetadata()
  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>SVS Printers and Bags | thamboolam, wedding, and gift bags in coimbatore at affordable price</title>
        <meta name="description" content="SVS Printers and Bags is a leading manufacturer of custom jute and eco-friendly thamboolam, wedding, and gift bags in coimbatore. We specialize in high-quality, reusable, and sustainable bags, perfect for all types of events. Wholesale and personalized options available" />
        <meta name="keywords" content="Thamboolam bags in coimbatore, Wedding bags in coimbatore, Jute bags in coimbatore, Gift bags in coimbatore, Marriage bags in coimbatore, ribbon badge in coimbatore" />

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix('/')}img/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/favicon-32x32.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/favicon-16x16.png`}
          sizes="16x16"
        />

        <link
          rel="mask-icon"
          href={`${withPrefix('/')}img/safari-pinned-tab.svg`}
          color="#ff4400"
        />
        <meta name="theme-color" content="#fff" />

        <meta property="og:type" content="business.business" />
        <meta property="og:title" content={title} />
        <meta property="og:url" content="/" />
        <meta
          property="og:image"
          content={`${withPrefix('/')}img/og-image.jpg`}
        />
      </Helmet>
      <Navbar />
      <div>{children}</div>
      <Footer />
    </div>
  )
}

export default TemplateWrapper
